import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';
import { StatisticValueType } from '../subCategory';
import { Order } from '../types';

export type StatisticData = AnyObject

export type StatisticResponse = StatisticData
export type StatisticColumns = 'id' | 'name' | 'avgValue' | 'createdAt' | 'updatedAt';

export interface StatisticParams {
  countryName?: string;
  countryId?: number;
  type?: StatisticValueType
  getAll?: boolean;
  orderBy?: Order
  orderByColumn?: StatisticColumns
}

const statisticDefaultParams: Partial<StatisticParams> = {
  // type: 'actual',
};

export const statisticList = (payload: StatisticParams): Action<StatisticParams> => ({
  type: actions.internationalStatisticTrigger.toString(),
  payload,
});

export const statisticListClear = (): Action => ({
  type: actions.internationalStatisticClear.toString(),
});

export const statisticListErrorClear = (): Action => ({
  type: actions.internationalStatisticErrorReset.toString(),
});

export function* statisticListRequestSaga({ payload }: Action<StatisticParams>) {
  yield put({
    type: actions.internationalStatisticStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.internationalStatisticError.toString(),
      payload: {
        message: 'Statistic: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries({
    ...statisticDefaultParams,
    ...payload,
  })
    .map(([key, value]) => [key, value ? value.toString() : ''])
    .filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}internationals/statistic?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<StatisticData, StatisticResponse>(
    response,
    actions.internationalStatisticSuccess.toString(),
    actions.internationalStatisticError.toString(),
    false,
    (statisticListData) => statisticListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.internationalStatisticTrigger.toString(),
    defaultProcessingSaga(
      statisticListRequestSaga,
      {
        error: actions.internationalStatisticError.toString(),
        locationCancel: actions.internationalStatisticErrorReset.toString(),
      },
    ),
  );
}
